import { render, staticRenderFns } from "./amgnTable.vue?vue&type=template&id=11077774"
import script from "./amgnTable.vue?vue&type=script&lang=js"
export * from "./amgnTable.vue?vue&type=script&lang=js"
import style0 from "./amgnTable.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports